<template>
    <div>
        <div @click="getRegions()">
            <span class="rdsButton" @click="modal1 = true">+</span>
        </div>
       <Modal v-model="modal1" :title="$t('Bill.CostCalculation.addRDS')" @on-ok="handleSubmit('RelationalDatabaseServiceForm')" @on-cancel="handleReset('RelationalDatabaseServiceForm')" width="900px;" :loading="modalLoading" :ok-text="$t('Bill.CostCalculation.add')" :mask-closable="false" :styles="{top:'35px'}" >
            <Form :model="RelationalDatabaseServiceForm" :label-width="80" ref="RelationalDatabaseServiceForm" :rules="ruleValidate">
                <!-- 搜索 -->
                <Row>
                    <!-- 地区 -->
                    <Col span="3">
                        <FormItem :label="$t('Bill.CostCalculation.areaColon')" style="margin-left: -36px;font-weight: 600;">
                            <div>{{regionRDSDate}}</div>
                        </FormItem>
                    </Col>
                    <!-- 选择数据库类型 -->
                    <Col span="7">
                        <FormItem :label="$t('Bill.CostCalculation.databaseType')" :label-width="90" prop="databaseType">
                            <Select v-model="RelationalDatabaseServiceForm.databaseType" @on-change="findDatabaseType(RelationalDatabaseServiceForm.databaseType)">
                                <Option :value="item.dbType" v-for="item in databaseTypeList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- 选择付费类型 -->
                    <Col span="7">
                        <FormItem :label="$t('Bill.CostCalculation.paymentMethod')" prop="costType">
                            <Select v-model="RelationalDatabaseServiceForm.costType" @on-change="findCostType(RelationalDatabaseServiceForm.costType)">
                                <Option :value="item.riPaymentOption" v-for="item in costTypeList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- 选择部署方式 -->
                    <Col span="7">
                        <FormItem :label="$t('Bill.CostCalculation.deploymentMethod')" prop="deploymentOption">
                            <Select v-model="RelationalDatabaseServiceForm.deploymentOption" @on-change="findDeploymentOption(RelationalDatabaseServiceForm.deploymentOption)">
                                <Option :value="item.deploymentOption" v-for="item in deploymentOptionList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Table :no-data-text="$t('common.noData')" highlight-row ref="selection" :columns="columns" :loading="loading" :data="relationalDatabaseServiceData" :height="400" @on-current-change="getSelection"></Table>
                <FormItem>
                    <!-- 北京 -->
                    <div v-show="placeBeijing" style="font-size: 14px;margin-top: 10px;margin-left: -79px;">{{ $t('Bill.CostCalculation.price') }}：￥{{priceBeijing}} / <span>{{ $t('Bill.CostCalculation.month') }}</span> </div>
                    <!-- 新加坡 -->
                    <div v-show="placeSingapore" style="font-size: 14px;margin-top: 10px;margin-left: -79px;">{{ $t('Bill.CostCalculation.price') }}：${{priceSingapore}} / <span>{{ $t('Bill.CostCalculation.month') }}</span> </div>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: 'AddRelationalDatabaseService',
        props:['regionRDSDate'],
        data (){
            return {
                dbEdition:'',
                priceBeijing:'0.00',
                priceSingapore:'0.00',
                placeBeijing:true,
                placeSingapore:true,
                ramSize:'',
                instanceType:'',
                cpuCoreNumber:'',
                cpus:'',
                memorys:'',
                region: '',
                regions:'',
                instanceType:'',
                RelationalDatabaseServiceForm: {
                    databaseType: '0',
                    costType: '0',
                    deploymentOption:'0'
                },
                databaseTypeList: [{
                    id: 0,
                    name: 'MySQL',
                    dbType: '0'
                },{
                    id: 1,
                    name: 'SQLServerEnterprise',
                    dbType: '1'
                },{
                    id: 2,
                    name: 'SQLServerStandard',
                    dbType: '2'
                }],
                costTypeList: [{
                    id: 0,
                    name: this.$t('Bill.CostCalculation.onDemandInstance'),
                    riPaymentOption: '0'
                },{
                    id: 1,
                    name: this.$t('Bill.CostCalculation.noUpfrontStandard1Year'),
                    riPaymentOption: '1'
                }],
                deploymentOptionList: [{
                    id: 0,
                    name: this.$t('Bill.CostCalculation.singleZone'),
                    deploymentOption: '0'
                },{
                    id: 1,
                    name: this.$t('Bill.CostCalculation.multiZone'),
                    deploymentOption: '1'
                }],
                selection:[],
                modal1:false,
                modalLoading: true,
                loading: false,
                columns: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'CPU',
                        key: 'cpuCoreNumber'
                    },
                    {
                        title: this.$t('Bill.CostCalculation.cache'),
                        key: 'ramSize'
                    }
                ],
                ruleValidate: {
                    databaseType: [
                        { required: true, message: this.$t('Bill.CostCalculation.pleaseSelectDatabaseType'), trigger: 'change' }
                    ],
                    costType: [
                        { required: true, message: this.$t('Bill.CostCalculation.pleaseSelectPaymentMethod'), trigger: 'change' }
                    ],
                    deploymentOption: [
                        { required: true, message: this.$t('Bill.CostCalculation.pleaseSelectDeploymentMethod'), trigger: 'change' }
                    ]
                },
                relationalDatabaseServiceData: []
            }
        },
        methods: {
            getRegions: function(){
                if(this.regionRDSDate=='北京'){
                    this.region='CN_NORTH_1';
                    this.placeBeijing=true;
                    this.placeSingapore=false;
                }else if(this.regionRDSDate=='新加坡'){
                    this.region='AP_SOUTHEAST_1';
                    this.placeSingapore=true;
                    this.placeBeijing=false;
                }

                // 查询实例CPU和RAM列表
                /***************************************************************/
                this.loading = true;
                var updateData = {
                    "region" : this.region,
                    "term" : this.RelationalDatabaseServiceForm.costType,
                    "deploymentOption": this.RelationalDatabaseServiceForm.deploymentOption
                    // "licenseModel" : 0
                };

                // 如果dbType是SQLServerEnterprise、SQLServerStandard     dbType为1
                if(this.RelationalDatabaseServiceForm.databaseType==1){
                    updateData.dbType = "1";
                    updateData.dbEdition = 1;
                }else if(this.RelationalDatabaseServiceForm.databaseType==2){
                    updateData.dbType = "1";
                    updateData.dbEdition = 3;
                }else if(this.RelationalDatabaseServiceForm.databaseType==0){
                    updateData.dbType =this.RelationalDatabaseServiceForm.databaseType;
                    updateData.dbEdition = 0;
                }
                // 查询当前EC2价格
                if(this.RelationalDatabaseServiceForm.costType==1){
                    updateData.riTenancy = 0;
                    updateData.riOfferingClass = 0;
                    updateData.leaseContractLength = 0;
                    updateData.riPaymentOption = 0;
                }
                
                this.$api.price.listRDSInstanceCoreAndRam(updateData)
                .then(res => {
                    this.loading = false;
                    this.relationalDatabaseServiceData=res.data;
                    for(var i=0;i<this.relationalDatabaseServiceData.length;i++){
                        this.relationalDatabaseServiceData[i].cpuCoreNumber=this.relationalDatabaseServiceData[i].cpuCoreNumber+this.$t('Bill.CostCalculation.core');
                        this.relationalDatabaseServiceData[i].ramSize=this.relationalDatabaseServiceData[i].ramSize+'G';
                    }
                })
            },
            // 数据库类型
            findDatabaseType: function(){
                // 查询实例CPU和RAM列表
                this.getRegions();
                this.priceBeijing="0.00";
                this.priceSingapore="0.00";
            },
            // 付费类型
            findCostType: function(){
                // 查询实例CPU和RAM列表
                this.getRegions();
                this.priceBeijing="0.00";
                this.priceSingapore="0.00";
            },
            // 部署方式
            findDeploymentOption: function(){
                // 查询实例CPU和RAM列表
                this.getRegions();
                this.priceBeijing="0.00";
                this.priceSingapore="0.00";
            },
            // 当前选择
            getSelection:function(selection){
                if(selection==null){
                    return;
                }
                this.ramSize=selection.ramSize;
                this.cpus=selection.cpuCoreNumber;
                this.cpus=this.cpus.replace(this.$t('Bill.CostCalculation.core'),"");
                this.memorys=selection.ramSize;
                this.memorys=this.memorys.replace('G',"");
                var updateData = {
                    "region" : this.region,
                    "cpuCoreNumber" : this.cpus,
                    "ramSize" : this.memorys,
                    "term" : this.RelationalDatabaseServiceForm.costType,
                    "deploymentOption": this.RelationalDatabaseServiceForm.deploymentOption
                    // "licenseModel" : 0
                };
                // 如果dbType是SQLServerEnterprise、SQLServerStandard     dbType为1
                if(this.RelationalDatabaseServiceForm.databaseType==1){
                    updateData.dbType = "1";    
                    updateData.dbEdition = 1;
                }else if(this.RelationalDatabaseServiceForm.databaseType==2){
                    updateData.dbType = "1";
                    updateData.dbEdition = 3;
                }else if(this.RelationalDatabaseServiceForm.databaseType==0){
                    updateData.dbType =this.RelationalDatabaseServiceForm.databaseType;
                    updateData.dbEdition = 0;
                }
                // 查询当前EC2价格
                if(this.RelationalDatabaseServiceForm.costType==1){
                    updateData.riTenancy = 0;
                    updateData.riOfferingClass = 0;
                    updateData.leaseContractLength = 0;
                    updateData.riPaymentOption = 0;
                }
                this.$api.price.getRDSInstancePrice(updateData)
                .then(res => {
                    //北京
                    this.priceBeijing=res.data.monthlyCostByRMB.toFixed(2);
                    //新加坡
                    this.priceSingapore=res.data.monthlyCostByDollars.toFixed(2);
                    //实例类型
                    this.instanceType=res.data.instanceType;
                    //区域
                    this.regions=res.data.region;
                    //数据库版本
                    this.dbEdition=res.data.dbEdition;
                })
                .catch(err=>{
                    this.priceBeijing="0.00";
                    this.priceSingapore="0.00";
                })
            },
            handleSubmit: function(name) {
                this.$refs[name].validate((valid) => {
                    if (valid&&this.ramSize!=''&&this.priceBeijing!=0.00||this.priceSingapore!=0.00) {
                        var RDSListCopy=new Object();
                        RDSListCopy.usage='';
                        RDSListCopy.region=this.regionRDSDate;
                        RDSListCopy.cpuCoreNumber=this.cpus;
                        RDSListCopy.ramSize=this.memorys;
                        RDSListCopy.dbType=this.RelationalDatabaseServiceForm.databaseType;
                        RDSListCopy.paymentType=this.RelationalDatabaseServiceForm.costType;
                        RDSListCopy.deploymentOption=this.RelationalDatabaseServiceForm.deploymentOption;
                        RDSListCopy.number=1;
                        RDSListCopy.priceBeijing=this.priceBeijing;
                        RDSListCopy.priceSingapore=this.priceSingapore;
                        RDSListCopy.month=1;
                        RDSListCopy.instanceType=this.instanceType;
                        RDSListCopy.regions=this.regions;
                        RDSListCopy.dbEdition=this.dbEdition;
                        // 传值
                        this.$emit('addRDSCallBack',RDSListCopy);
                        setTimeout(() => {
                            this.modalLoading = false;
                            this.$nextTick(() => {
                                this.modalLoading = true;
                            });
                            this.ramSize='';
                            this.priceBeijing="0.00";
                            this.priceSingapore="0.00";
                            this.$refs.selection.clearCurrentRow();                             
                            this.$Message.success(this.$t('common.addSuccess'));    
                            this.modal1 = false;
                        },1000);                 
                    }                     
                    else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                    }
                });
            },
            handleReset: function(name) {
                this.ramSize='';
                this.priceBeijing="0.00";
                this.priceSingapore="0.00";
                this.$refs.selection.clearCurrentRow();
            }
        }
    }
</script>

<style scoped>
    .rdsButton
    {
        float: right;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: block;
        background-color: #2db7f5;
        text-align: center;
        line-height: 25px;
        color: #fff;
        font-size: 19px;
        margin-top: 7px;
        margin-right: 10px;
        cursor:pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/cost_calculation/AddRelationalDatabaseService.vue